var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-modal',{attrs:{"id":_vm.id,"title":_vm.modalTitle},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('x-close-modal-button')]},proxy:true}])},[_c('x-table',{attrs:{"headers":[
        'Nama',
        'Linked Event',
    ]}},_vm._l((_vm.eventForms),function(eventForm,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(eventForm.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("get")(eventForm,'event.label', '-')))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }